import { matchPath, useLocation } from 'react-router-dom';
import {
  MBox,
  MCustomLinkTab,
  MTabList,
  MTabs,
} from '../../../components/Monetize';
import { ROUTES } from '../../../constants';

const CatalogTabs = ({
  featureFlags,
}: {
  featureFlags: Record<string, any>; // not using FeatureFlag because it has too many properties
}) => {
  const location = useLocation();
  const { enableTokenCredits } = featureFlags;

  const tabRoutes = [
    { title: 'Products', route: ROUTES.PRODUCT_LIST, enabled: true },
    { title: 'Offerings', route: ROUTES.OFFERING_LIST, enabled: true },
    { title: 'Discounts', route: ROUTES.DISCOUNT_LIST, enabled: true },
    { title: 'Usage Types', route: ROUTES.USAGE_TYPE_LIST, enabled: true },
    {
      title: 'Buckets',
      route: ROUTES.BUCKET_LIST,
      enabled: enableTokenCredits,
    },
  ];

  const defaultIndex = tabRoutes.findIndex((route) => {
    return matchPath(route.route, location.pathname);
  });

  return (
    <MBox w="100%">
      <MTabs
        data-testid="product-catalog-top-nav"
        size="sm"
        defaultIndex={defaultIndex}
        // `MCustomLinkTab`s navigate themselves — see its doc comment.
        navigate={null}
      >
        <MTabList alignItems="flex-end">
          {tabRoutes
            .filter((route) => route.enabled)
            .map((tabRoute, index) => (
              <MCustomLinkTab to={tabRoute.route} key={index}>
                {tabRoute.title}
              </MCustomLinkTab>
            ))}
        </MTabList>
      </MTabs>
    </MBox>
  );
};

export default CatalogTabs;
